import { createNavigation } from 'next-intl/navigation'
import { routing } from '@/i18n/routing'

/**
 * Locale-aware drop-in replacements for Next navigation. ALWAYS import these
 * (not `next/link` / `next/navigation`) in UI code so links and redirects keep
 * the visitor's language prefix.
 */
export const { Link, redirect, permanentRedirect, usePathname, useRouter, getPathname } =
  createNavigation(routing)
